import React, { useState, useEffect } from "react";
import {
	IonCard,
	IonCardContent,
	IonCardHeader,
	IonCardTitle,
	IonToolbar,
	IonCol,
	IonGrid,
	IonRow,
	IonContent,
	IonButton,
	IonButtons,
	IonHeader,
	IonMenuButton,
	IonPage,
	IonTitle,
	IonSearchbar,
	IonIcon,
	useIonAlert
} from "@ionic/react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NoDataFound from "../../components/NoDataFound";
import PlusIcon from "../../components/PlusIcon";
import useStore from "../../store/store";
import { shieldCheckmark, trashBinOutline } from "ionicons/icons";
import { Phone } from "../../controls";

const List: React.FC = () => {
	const { t } = useTranslation();
	const { token, user } = useStore(state => state);
	const [data, setData] = useState<any[]>([]);
	const history = useHistory();
	const [keyword, setKeyword] = useState<string>("");
	const [presentAlert] = useIonAlert();

	useEffect(() => {
		getData();
	}, [keyword]);

	const getData = () => {
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/users/all`,
				{
					keyword: keyword
				},
				{ headers: { rentapp_auth: token } }
			)
			.then(res => setData(res.data))
			.catch(err => console.log(err));
	};

	const handleDelete = (id: any) => {
		presentAlert({
			header: `${t("sureToDel")}`,
			buttons: [
				{
					text: `${t("cancel")}`,
					role: "cancel"
				},
				{
					text: `${t("yes")}`,
					role: "confirm",
					handler: () => {
						axios
							.delete(
								`${process.env.REACT_APP_API_URL}/users/${id}`,
								{
									headers: { rentapp_auth: token }
								}
							)
							.then(res => {
								getData();
							})
							.catch(err => console.log(err));
					}
				}
			]
		});
	};

	return (
		<IonPage>
			<IonHeader>
				<IonToolbar>
					<IonButtons slot="start">
						<IonMenuButton />
					</IonButtons>
					<IonButtons slot="end">
						{user.type === "admin" && (
							<IonButton
								onClick={(e: any) => {
									e.preventDefault();
									history.push("/users/new");
								}}
							>
								<PlusIcon />
							</IonButton>
						)}
					</IonButtons>
					<IonTitle>{t("users")}</IonTitle>
				</IonToolbar>
			</IonHeader>

			<IonContent fullscreen>
				<IonHeader collapse="condense">
					<IonToolbar>
						<IonTitle size="large">{t("users")}</IonTitle>
					</IonToolbar>
				</IonHeader>
				<IonGrid>
					<IonRow>
						<IonSearchbar
							showClearButton="focus"
							debounce={500}
							onIonChange={e => setKeyword(e.target.value || "")}
						></IonSearchbar>
					</IonRow>
					<IonRow>
						{data.length === 0 && <NoDataFound />}
						{data.map((elem, index) => (
							<IonCol
								size-xs="12"
								size-sm="12"
								size-md="6"
								key={elem?._id}
							>
								<IonCard color="light">
									<IonCardHeader>
										<IonCardTitle
											style={{
												fontSize: 18,
												fontWeight: "bold"
											}}
										>
											{elem?.name}
											{elem?.type === "admin" && (
												<IonIcon
													color="primary"
													style={{ marginLeft: 10 }}
													icon={shieldCheckmark}
												></IonIcon>
											)}
											{user.type === "admin" &&
												elem?.type === "user" && (
													<IonIcon
														icon={trashBinOutline}
														style={{
															marginLeft: 10
														}}
														color="danger"
														onClick={() =>
															handleDelete(
																elem?._id
															)
														}
													></IonIcon>
												)}
										</IonCardTitle>
									</IonCardHeader>
									<IonCardContent>
										<Phone
											displayType="text"
											value={elem?.phone}
										/>
										<div>{elem?.email}</div>
									</IonCardContent>
								</IonCard>
							</IonCol>
						))}
					</IonRow>
				</IonGrid>
			</IonContent>
		</IonPage>
	);
};

export default List;
